import { NotificationManager } from 'react-notifications';
import { alertForDocumentToBeSignedNotAllowed } from '../constants/AlertForDocumentToBeSignedNotAllowed';

export const showAlertForDocumentToBeSignedNotAllowed = () => {
  NotificationManager.error(alertForDocumentToBeSignedNotAllowed);
};
